export default __webpack_public_path__ + "static/media/logo.min.3d1eb739.gif";